import { routes as home } from "./home";
import { routes as catalogo } from "./catalogo";
import { routes as paginaDinamica } from "./pagina-dinamica";
import { routes as produto } from "./produto";

import { routes as atendimento } from "./atendimentoNew";
import { routes as trabalheConosco } from "./trabalhe-conosco-novo";
import { routes as paginaCliente } from "./pagina-cliente";

import { routes as checkout } from "./checkout";
import { routes as notFound } from "./404";
import { routes as maintenance } from "./maintenance";
import { routes as campanha } from "./campanhas";
import { routes as seller } from "./seller";

const redirecionamentos = [
  {
    path: "/produto",
    redirect: (to) => {
      try {
        const array = to.query.codigo.split("-");
        return { path: `/produto/${array[0]}`, params: { codigo: array[0] } };
      } catch (e) {}
    },
  },
  {
    path: "/old/produto/:produto",
    redirect: (to) => {
      const array = to.params.produto.split("-");
      return { path: "/produto", query: { codigo: array[0] } };
    },
  },

  {
    path: "*",
    redirect: (to) => ({ path: "404", params: {} }),
  },
];

export default [
  ...home,
  ...catalogo,
  ...checkout,
  ...produto,
  ...paginaDinamica,
  ...atendimento,
  ...trabalheConosco,
  ...redirecionamentos,
  ...paginaCliente,
  ...notFound,
  ...campanha,
  ...seller,
  ...maintenance,
];
